module.exports = __webpack_public_path__ + "img/chance.626369f0.png";